interface ShopperAgentCapabilityTeam {
  settings: {
    shopperAgentAdmin?: { enabled?: boolean | null };
    recover?: { enabled?: boolean };
  };
}

export function shopperAgentCapabilityEnabled(
  team: ShopperAgentCapabilityTeam,
): boolean {
  return team.settings.shopperAgentAdmin?.enabled === true;
}

/**
 * Commerce Agent is visible to teams whose staff unlocked the capability,
 * and to every Recover team, which builds on the same agent.
 */
export function shopperAgentEnabled(team: ShopperAgentCapabilityTeam): boolean {
  return (
    shopperAgentCapabilityEnabled(team) ||
    team.settings.recover?.enabled === true
  );
}
